import { render, staticRenderFns } from "./BroadcastList.vue?vue&type=template&id=76ad2fda&scoped=true&"
import script from "./BroadcastList.vue?vue&type=script&lang=js&"
export * from "./BroadcastList.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastList.vue?vue&type=style&index=0&id=76ad2fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ad2fda",
  null
  
)

export default component.exports